import { z } from 'zod';

// ---------------------------------------------------------------------------
// On-demand copilot suggestion — POST /api/conversations/:id/copilot-suggest
//
// Consultant-agents H1.1 (copilot on-demand). When a Copilot agent runs with
// `copilot_trigger: 'on_demand'`, the automatic per-message suggestion is
// suppressed; the support team pulls one explicitly through this endpoint (the
// "Suggest reply" button). It fires the SAME internal, team-facing Copilot
// suggestion the automatic path produces — no new inbound message, no channel
// delivery — so nothing about copilot rendering/click-to-copy changes.
//
// `conversation_id` is the path param (`conversationIdParam`); the body carries
// `hub_id` so the route can authorize support access to the hub and verify the
// conversation belongs to it (IDOR guard), matching the claim/transfer routes.
// ---------------------------------------------------------------------------

export const copilotSuggestBody = z.object({
  hub_id: z.string().uuid(),
});

/**
 * `processing` — a Copilot suggestion turn was dispatched (fire-and-forget; the
 * suggestion arrives over the live-update broadcast, not this response).
 * `skipped` — the conversation is not in an on-demand-eligible Copilot state; `reason`
 * carries the specific cause for the caller to surface: `ended`, `not_copilot` (pilot
 * track / turned off / no Copilot agent), or `not_approved` (a pending/blocked contact,
 * which never triggers the AI — not even Copilot suggestions).
 */
export const copilotSuggestResponse = z.object({
  status: z.enum(['processing', 'skipped']),
  reason: z.string().optional(),
});
export type CopilotSuggestResponse = z.infer<typeof copilotSuggestResponse>;
